module.exports = __webpack_public_path__ + "static/type-koalas-19eb8f32893a917af60ea5dcf7bbef46.png";